module.exports = __webpack_public_path__ + "media/1x1/kr-7fb0181b.svg";